export const signup = {
  extends: 'Page',
  metadata: { title: 'Create account / Symbols' },
  flow: 'y',
  align: 'center center',
  padding: 'D C',
  width: '100%',
  minHeight: '100dvh',
  maxWidth: 'none',

  onInit: (el, s) => {
    const searchParams = new URLSearchParams(window.location.search)
    const hasToken = searchParams.has('token')
    if (hasToken) {
      const token = searchParams.get('token')
      const splittedToken = token.split('.')
      if (splittedToken.length > 1) {
        try {
          const decodedToken = JSON.parse(atob(splittedToken[1]))
          s.quietUpdate({ email: decodedToken.email, hasToken })
        } catch (e) {
          console.error('Problem with Signup Token', e)
        }
      }
    }
  },

  SignupCard: {
    flow: 'y',
    gap: 'C',
    padding: 'D',
    width: '100%',
    maxWidth: 'I',
    round: 'C',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    boxShadow: '0 24px 60px -24px var(--color-shadow)',

    Head: {
      flow: 'y',
      gap: 'A',
      Eyebrow: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '700',
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: 'blue',
        text: 'Sign up'
      },
      Title: {
        tag: 'h1',
        fontSize: 'D',
        fontWeight: '800',
        color: 'title',
        letterSpacing: '-0.02em',
        text: 'Create account'
      },
      Sub: {
        tag: 'p',
        color: 'caption',
        fontSize: 'A',
        text: 'Join Symbols. Enter your details below.'
      }
    },

    Form: {
      tag: 'form',
      flow: 'y',
      gap: 'A',

      onSubmit: async (ev, el, s) => {
        ev.preventDefault()
        const root = el.node
        const email = (root.querySelector('input[name="email"]')?.value || '').trim().toLowerCase()
        const password = root.querySelector('input[name="password"]')?.value || ''
        const name = (root.querySelector('input[name="name"]')?.value || '').trim()
        const errBox = root.querySelector('[data-lg-err]')
        if (errBox) errBox.textContent = ''
        if (!email || !password || !name) {
          if (errBox) errBox.textContent = 'All fields are required.'
          return
        }
        s.update({ loading: true })
        const currentUrl = new URL(window.location.href)
        const token = currentUrl.searchParams.get('token')
        try {
          const pluginSession = el.call('getPluginSessionFromUrl')
          const payload = {
            email,
            password,
            name,
            callbackUrl: `${window.location.origin}/signup-confirmation`,
            inviteToken: token
          }
          if (pluginSession) {
            await el.sdk.register(payload, { session: pluginSession })
          } else {
            await el.sdk.register(payload)
          }
        } catch (ex) {
          if (errBox) errBox.textContent = ex?.message || String(ex)
          el.call('openNotification', { title: 'Error message', message: `${ex}`, type: 'error' })
          s.update({ loading: false })
          el.call('applyLoader', { value: false, force: true, timeout: 1 })
          return
        }
        s.update({ loading: false })
        if (el.isAuthorised?.()) await el.call('fetchUser')
        el.call('applyLoader', { value: false, force: true, timeout: 1 })
        if (window.plausible) window.plausible('Signup')
        el.call('openNotification', {
          title: 'Success',
          message: 'You will receive an email confirmation link on the email address you signed up with.',
          type: 'success'
        })
        setTimeout(() => el.router('/dashboard', el.getRoot()), 350)
      },

      Name: {
        tag: 'input',
        width: '100%',
        padding: 'A B',
        round: 'C',
        background: 'overlayStrong',
        border: 'none',
        outline: 'none',
        color: 'title',
        fontSize: 'A',
        boxSizing: 'border-box',
        type: 'text',
        name: 'name',
        placeholder: 'Full name',
        required: 'true',
        autocomplete: 'name'
      },
      Email: {
        tag: 'input',
        width: '100%',
        padding: 'A B',
        round: 'C',
        background: 'overlayStrong',
        border: 'none',
        outline: 'none',
        color: 'title',
        fontSize: 'A',
        boxSizing: 'border-box',
        type: 'email',
        name: 'email',
        placeholder: 'name@symbols.app',
        required: 'true',
        autocomplete: 'email'
      },
      Password: {
        tag: 'input',
        width: '100%',
        padding: 'A B',
        round: 'C',
        background: 'overlayStrong',
        border: 'none',
        outline: 'none',
        color: 'title',
        fontSize: 'A',
        boxSizing: 'border-box',
        type: 'password',
        name: 'password',
        placeholder: 'Password',
        required: 'true',
        autocomplete: 'new-password'
      },

      Error: { tag: 'span', 'data-lg-err': 'true', fontSize: 'Z2', color: 'red', minHeight: 'A' },

      Submit: {
        tag: 'button',
        type: 'submit',
        width: '100%',
        padding: 'A B',
        round: 'C',
        background: 'blue',
        color: 'white',
        fontSize: 'A',
        fontWeight: '700',
        border: 'none',
        cursor: 'pointer',
        text: 'Create account'
      }
    },

    Footer: {
      tag: 'span',
      fontSize: 'Z2',
      color: 'caption',
      align: 'center',
      text: 'Already have an account?',
      SigninLink: {
        tag: 'a',
        href: '/signin',
        fontSize: 'Z2',
        color: 'blue',
        marginLeft: 'Y',
        text: 'Sign in'
      }
    }
  }
}
